module.exports = require("lodash");


//////////////////
// WEBPACK FOOTER
// external "lodash"
// module id = lodash
// module chunks = 3